import { render, staticRenderFns } from "./RatingTicketAnswersList.vue?vue&type=template&id=2b98ee60&scoped=true"
import script from "./RatingTicketAnswersList.vue?vue&type=script&lang=js"
export * from "./RatingTicketAnswersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b98ee60",
  null
  
)

export default component.exports